import * as React from 'react';
import './CustomPagination.css';
import { CustomButtonGroup} from '../globalExports';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { Menu, MenuItem } from '@mui/material';
import { Icon } from '../globalIcons';

type CustomPaginationProps = {
    page:number,
    pageSize:number,
    onPageChange:(event:React.MouseEvent<HTMLButtonElement> | null,pagenumber:number)=>void,
    onPageSizeChange:(event:React.MouseEvent<HTMLButtonElement> | null,pageSize:number)=>void
}

export const CustomPagination:React.FC<CustomPaginationProps> = (props) => {
  const {page,pageSize,onPageChange,onPageSizeChange} = props;
  const [anchorEl,setAnchorEl] = useState<HTMLElement | null>(null);
  const pageOptions = [10,15,25,50,100];

  const handlePrev = (event) => {
    if(page==1)return;
    onPageChange(event,page-1);
  };

  const handleNext = (event) => {
    onPageChange(event,page+1);
  };

  const handleChangePageSizeBtnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const actionBtns = [
    {
        btnClassName:'custom__pagination__prev__btn',
        buttonId:'custom-pagination-prev-btn',
        buttonText:'Prev',
        buttonIconClassName:'',
        handleClick:handlePrev,
        isDisabled:page==1
    },
    {
        btnClassName:'custom__pagination__next__btn',
        buttonId:'custom-pagination-next-btn',
        buttonText:'Next',
        buttonIconClassName:'',
        handleClick:handleNext,
    },
  ]
  
  const handleMenutItemClicked = (event,val)=>{
    onPageSizeChange(event,val);
    setAnchorEl(null);
  }

  return (
    <div className='custom-pagination-footer'>
        <div className='custom-pagination-footer-left-container'>
          <div className='custom-pagination-footer-rows-per-page-heading'>Rows per page:</div>
          <div className='custom-pagination-footer-rows-per-page-body'>
            <Button 
            id='custom-pagination-footer-rows-per-page-btn'
            onClick={handleChangePageSizeBtnClick}>
              <span className='custom-pagination-footer-rows-per-page-btn-count'>{pageSize}</span>
              <Icon iconClassName='rms__down-black-arrow' containerClassName={'custom-pagination-footer-rows-per-page-btn-icon'}/>
            </Button>
            <Menu
             id={'custom-pagination-footer-rows-per-page-list'}
             anchorEl={anchorEl}
             open={Boolean(anchorEl)}
             onClose = {()=>{setAnchorEl(null)}}
            >
              {pageOptions.map(item=>{
                return (
                  <MenuItem key={'custom-pagination-footer-rows-per-page-option-'+item} onClick={(event)=>handleMenutItemClicked(event,item)} selected={pageSize==item}>
                    <div className='custom-pagination-footer-rows-per-page-option'>{item}</div>
                  </MenuItem>
                )
              })}
            </Menu>
          </div>
        </div>
        <div className='custom-pagination-footer-right-container'>
            <CustomButtonGroup buttonsList={actionBtns} buttonGroupClassName={'custom__pagination__footer__action__btn__container'}/>
        </div>
    </div>
  );
}
